
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 5c3.378 0 6.14 2.131 7.344 5.063 3.527.182 6.33 2.986 6.563 6.5 1.239 1.102 2.094 2.677 2.094 4.438 0 3.324-2.676 6-6 6h-20c-3.324 0-6-2.676-6-6 0-2.751 1.884-4.944 4.344-5.656a4.897 4.897 0 013.844-3.219c.454-3.994 3.694-7.125 7.813-7.125zm0 2c-3.37 0-6 2.63-6 6v1H9c-1.444 0-2.638.964-2.938 2.313l-.125.656-.656.125A3.941 3.941 0 002 21c0 2.276 1.724 4 4 4h20c2.276 0 4-1.724 4-4 0-1.267-.65-2.48-1.594-3.188L28 17.499v-.5c0-2.755-2.245-5-5-5h-1.031l-.219-.719c-.779-2.51-2.988-4.281-5.75-4.281zm-1 5h2v6.563l2.281-2.281 1.438 1.438-4 4-.719.688-.719-.688-4-4 1.438-1.438L15 18.563V12z"}})])
          )
        }
      }
    